import { useId } from 'react';

export default function AIIcon({
  className,
}: {
  className: string | undefined;
}) {
  const baseId = useId();
  const midStar = useId();
  const leftStar = useId();
  const rightStar = useId();
  const fourthClip = useId();
  const thirdClip = useId();
  const secondClip = useId();
  const firstClip = useId();

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath={`url(#${baseId})`}>
        <g clipPath={`url(#${midStar})`}>
          <g transform="matrix(0.0108025 0 -2.56547e-06 0.0106899 13.322 10.6899)">
            <foreignObject
              x="-1000.24"
              y="-1000.24"
              width="2000.47"
              height="2000.47"
            >
              <svg
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  background:
                    'conic-gradient(from 90deg, rgba(58, 135, 253, 1) 0deg, rgba(124, 57, 203, 1) 62.3077deg, rgba(237, 46, 66, 1) 140.192deg, rgba(225, 153, 42, 1) 216.346deg, rgba(148, 247, 239, 1) 285.577deg, rgba(58, 135, 253, 1) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: 1,
                }}
              ></svg>
            </foreignObject>
          </g>
        </g>
        <g clipPath={`url(#${leftStar})`}>
          <g transform="matrix(0.0108025 0 -2.56547e-06 0.0106899 13.322 10.6899)">
            <foreignObject
              x="-1000.24"
              y="-1000.24"
              width="2000.47"
              height="2000.47"
            >
              <svg
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  background:
                    'conic-gradient(from 90deg, rgba(58, 135, 253, 1) 0deg, rgba(124, 57, 203, 1) 62.3077deg, rgba(237, 46, 66, 1) 140.192deg, rgba(225, 153, 42, 1) 216.346deg, rgba(148, 247, 239, 1) 285.577deg, rgba(58, 135, 253, 1) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: 1,
                }}
              ></svg>
            </foreignObject>
          </g>
        </g>
        <g clipPath={`url(#${rightStar})`}>
          <g transform="matrix(0.0108025 0 -2.56547e-06 0.0106899 13.322 10.6899)">
            <foreignObject
              x="-1000.24"
              y="-1000.24"
              width="2000.47"
              height="2000.47"
            >
              <svg
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  background:
                    'conic-gradient(from 90deg, rgba(58, 135, 253, 1) 0deg, rgba(124, 57, 203, 1) 62.3077deg, rgba(237, 46, 66, 1) 140.192deg, rgba(225, 153, 42, 1) 216.346deg, rgba(148, 247, 239, 1) 285.577deg, rgba(58, 135, 253, 1) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: 1,
                }}
              ></svg>
            </foreignObject>
          </g>
        </g>
        <g clipPath={`url(#${fourthClip})`}>
          <g transform="matrix(0.0108025 0 -2.56547e-06 0.0106899 13.322 10.6899)">
            <foreignObject
              x="-1000.24"
              y="-1000.24"
              width="2000.47"
              height="2000.47"
            >
              <svg
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  background:
                    'conic-gradient(from 90deg, rgba(58, 135, 253, 1) 0deg, rgba(124, 57, 203, 1) 62.3077deg, rgba(237, 46, 66, 1) 140.192deg, rgba(225, 153, 42, 1) 216.346deg, rgba(148, 247, 239, 1) 285.577deg, rgba(58, 135, 253, 1) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: 1,
                }}
              ></svg>
            </foreignObject>
          </g>
        </g>
        <g clipPath={`url(#${thirdClip})`}>
          <g transform="matrix(0.0108025 0 -2.56547e-06 0.0106899 13.322 10.6899)">
            <foreignObject
              x="-1000.24"
              y="-1000.24"
              width="2000.47"
              height="2000.47"
            >
              <svg
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  background:
                    'conic-gradient(from 90deg, rgba(58, 135, 253, 1) 0deg, rgba(124, 57, 203, 1) 62.3077deg, rgba(237, 46, 66, 1) 140.192deg, rgba(225, 153, 42, 1) 216.346deg, rgba(148, 247, 239, 1) 285.577deg, rgba(58, 135, 253, 1) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: 1,
                }}
              ></svg>
            </foreignObject>
          </g>
        </g>
        <g clipPath={`url(#${secondClip})`}>
          <g transform="matrix(0.0108025 0 -2.56547e-06 0.0106899 13.322 10.6899)">
            <foreignObject
              x="-1000.24"
              y="-1000.24"
              width="2000.47"
              height="2000.47"
            >
              <svg
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  background:
                    'conic-gradient(from 90deg, rgba(58, 135, 253, 1) 0deg, rgba(124, 57, 203, 1) 62.3077deg, rgba(237, 46, 66, 1) 140.192deg, rgba(225, 153, 42, 1) 216.346deg, rgba(148, 247, 239, 1) 285.577deg, rgba(58, 135, 253, 1) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: 1,
                }}
              ></svg>
            </foreignObject>
          </g>
        </g>
        <g clipPath={`url(#${firstClip})`}>
          <g transform="matrix(0.0108025 0 -2.56547e-06 0.0106899 13.322 10.6899)">
            <foreignObject
              x="-1000.24"
              y="-1000.24"
              width="2000.47"
              height="2000.47"
            >
              <svg
                xmlns="http://www.w3.org/1999/xhtml"
                style={{
                  background:
                    'conic-gradient(from 90deg, rgba(58, 135, 253, 1) 0deg, rgba(124, 57, 203, 1) 62.3077deg, rgba(237, 46, 66, 1) 140.192deg, rgba(225, 153, 42, 1) 216.346deg, rgba(148, 247, 239, 1) 285.577deg, rgba(58, 135, 253, 1) 360deg)',
                  height: '100%',
                  width: '100%',
                  opacity: 1,
                }}
              ></svg>
            </foreignObject>
          </g>
        </g>
      </g>
      <defs>
        <clipPath id={midStar}>
          <path d="M19.5735 0.979633C19.5882 0.925861 19.671 0.925861 19.6857 0.979633C19.8447 1.56088 20.3376 3.16728 21.1171 3.94673C21.8965 4.72619 23.5029 5.21913 24.0842 5.37807C24.1379 5.39277 24.1379 5.47556 24.0842 5.49026C23.5029 5.6492 21.8965 6.14214 21.1171 6.9216C20.3376 7.70105 19.8447 9.30745 19.6857 9.8887C19.671 9.94247 19.5882 9.94247 19.5735 9.8887C19.4146 9.30745 18.9216 7.70105 18.1422 6.9216C17.3627 6.14214 15.7563 5.6492 15.1751 5.49026C15.1213 5.47556 15.1213 5.39277 15.1751 5.37807C15.7563 5.21913 17.3627 4.72619 18.1422 3.94673C18.9216 3.16728 19.4146 1.56088 19.5735 0.979633Z" />
        </clipPath>
        <clipPath id={leftStar}>
          <path d="M15.7314 0.0400013C15.7476 -0.0133337 15.8344 -0.0133338 15.8506 0.0400012C15.9386 0.329402 16.1223 0.838604 16.3897 1.106C16.6571 1.3734 17.1663 1.55702 17.4557 1.64503C17.509 1.66124 17.509 1.74809 17.4557 1.76431C17.1663 1.85231 16.6571 2.03593 16.3897 2.30333C16.1223 2.57073 15.9386 3.07993 15.8506 3.36933C15.8344 3.42267 15.7476 3.42267 15.7314 3.36933C15.6434 3.07993 15.4597 2.57073 15.1923 2.30333C14.9249 2.03593 14.4157 1.85231 14.1263 1.76431C14.073 1.74809 14.073 1.66124 14.1263 1.64503C14.4157 1.55702 14.9249 1.3734 15.1923 1.106C15.4597 0.838604 15.6434 0.329402 15.7314 0.0400013Z" />
        </clipPath>
        <clipPath id={rightStar}>
          <path d="M22.69 1.57871C22.7079 1.52591 22.7985 1.52591 22.8164 1.57871C22.8749 1.75163 22.9731 1.98746 23.1067 2.12106C23.2403 2.25466 23.4761 2.35285 23.649 2.41137C23.7018 2.42924 23.7018 2.51984 23.649 2.53771C23.4761 2.59624 23.2403 2.69442 23.1067 2.82802C22.9731 2.96162 22.8749 3.19745 22.8164 3.37037C22.7985 3.42317 22.7079 3.42317 22.69 3.37037C22.6315 3.19745 22.5333 2.96162 22.3997 2.82802C22.2661 2.69442 22.0303 2.59624 21.8574 2.53771C21.8046 2.51984 21.8046 2.42924 21.8574 2.41137C22.0303 2.35285 22.2661 2.25467 22.3997 2.12106C22.5333 1.98746 22.6315 1.75163 22.69 1.57871Z" />
        </clipPath>
        <clipPath id={fourthClip}>
          <path d="M20.8026 15.6945C18.9622 20.9741 11.8995 23.0752 6.07998 19.8477C13.865 20.1946 16.9005 18.5173 20.8026 15.6945Z" />
        </clipPath>
        <clipPath id={thirdClip}>
          <path d="M21.3044 10.3385C21.391 11.3113 21.4103 12.2268 21.2465 13.2767C16.8048 16.6583 10.2615 18.0655 4.49013 18.0173C4.06612 17.6798 3.26641 16.5619 3.0159 15.4447C8.62362 14.4152 13.8174 12.9192 18.9691 11.1551C19.307 11.0395 19.4772 10.9936 19.6928 10.9156C20.2049 10.7305 20.743 10.5367 21.102 10.4087C21.1692 10.3848 21.2372 10.3626 21.3044 10.3385Z" />
        </clipPath>
        <clipPath id={secondClip}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.308 6.60136C15.8964 6.9029 17.2489 7.87205 17.7984 9.36502C12.2029 10.5593 7.16775 12.0566 2.65973 13.894C2.46705 13.2774 2.51108 11.6631 2.56888 11.056C5.93089 8.57653 10.1849 7.1638 14.308 6.60136Z"
          />
        </clipPath>
        <clipPath id={firstClip}>
          <path d="M3.15114 8.32439C4.74099 3.77727 10.6308 2.01857 14.308 3.07168C15.0346 3.66133 14.3749 4.19616 13.9198 4.34872C9.99443 4.5988 6.29074 5.91802 3.15114 8.32439Z" />
        </clipPath>
        <clipPath id={baseId}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
